/* eslint-disable no-restricted-syntax */
import { Component, Host, h, Prop, Build, State } from '@stencil/core';
import { getDisclaimers } from '../../services';
import { Disclaimer } from '../rcm-disclaimer/rcm-disclaimer.types';

@Component({
  tag: 'rcm-disclaimer-container',
  shadow: true,
})
export class RcmDisclaimerContainer {
  @Prop({ mutable: true }) disclaimer: string | string[];

  @State() parsedDisclaimer: Disclaimer[];

  async componentWillLoad() {
    if (typeof this.disclaimer === 'string') {
      this.disclaimer = JSON.parse(this.disclaimer);
    }

    if (Build.isBrowser) {
      if (this.disclaimer) {
        if (typeof this.disclaimer === 'object') {
          this.parsedDisclaimer = await getDisclaimers(this.disclaimer || []);
        }
      }
    }
  }

  render() {
    return (
      <Host>
        <rcm-container style={{ marginTop: 'var(--spacings-xl)' }}>
          <rcm-disclaimer disclaimers={this.parsedDisclaimer} full big inline />
        </rcm-container>
      </Host>
    );
  }
}
